import { Box, Button, Stack, Typography } from "@mui/material";
import { useFormState } from "../../hooks/use-form-state";
import { OutlinedInput, OutlinedSelect } from "../../components";

type FormExampleInputs = {
  textInput: string;
  selectInput: string[];
};

const initialState = {
  textInput: "",
  selectInput: [],
};

const validations = (state: FormExampleInputs) => ({
  textInput: state.textInput !== "" ? undefined : "Text input is required",
  selectInput:
    state.selectInput.length > 0 ? undefined : "Select input is required",
});

export const FormExample = ({
  formValue,
}: {
  formValue?: FormExampleInputs;
}) => {
  const { state, handleChange, errors, handleSubmit } =
    useFormState<FormExampleInputs>({
      initialState: {
        ...initialState,
        ...formValue,
      },
      validate: validations,
      onSubmit: (state) => {
      },
    });

  return (
    <Box
      mt={{
        xs: 2,
        md: "30px",
      }}
    >
      <Typography variant="h1" mb={4}>
        Form Example
      </Typography>

      <Stack
        spacing={2}
        direction={{
          xs: "column",
          sm: "row",
        }}
      >
        <OutlinedInput
          onChange={handleChange("textInput")}
          value={state.textInput}
          label="Text Input"
          error={errors.textInput}
        />

        <OutlinedSelect
          options={[
            {
              label: "Option 1",
              value: "option1",
            },
            {
              label: "Option 2",
              value: "option2",
            },
          ]}
          onChange={handleChange("selectInput")}
          value={state.selectInput}
          label="Select Input"
          error={errors.selectInput}
        />

        <Button onClick={handleSubmit}>Submit</Button>
      </Stack>
    </Box>
  );
};
